import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateFileName'
})
export class TruncateFileNamePipe implements PipeTransform {

  transform(fileName: string | null | undefined, maxBaseLength: number = 50): string {

    if (!fileName) {
      return '';
    }

    const trimmedName = fileName.trim();
    const lastDotIndex = trimmedName.lastIndexOf('.');

    if (lastDotIndex <= 0 || lastDotIndex === trimmedName.length - 1) {
      return trimmedName.length > maxBaseLength
        ? trimmedName.substring(0, maxBaseLength) + '…'
        : trimmedName;
    }

    const baseName = trimmedName.substring(0, lastDotIndex);
    const extension = trimmedName.substring(lastDotIndex);

    if (baseName.length <= maxBaseLength) {
      return trimmedName;
    }

    return baseName.substring(0, maxBaseLength) + '…' + extension;
  }

}
